import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import { useGeoJson } from "../../contexts/GeoJsonContext";
import AreaDetailSidebar from "../AreaDetails/AreaDetailSidebar";


const ProcessImg = ({ fileName = "No file", setProcessBtn,setSelector}) => {
 const [ show , setShow ] = useState(false)
 const { geoJsonData } = useGeoJson();
 const [ kmlCoordinates , setKmlCoordinates ] = useState([])
 const handleShow = ()=>{
  setShow(true)
  setKmlCoordinates(geoJsonData)
 }

 const handleCancel = () => {
  setShow(false);
};

  return (
    <div className="w-full flex flex-col items-center">
      <div className="mt-4 w-[70%] ">
        <p className="text-xl font-semibold">Import file</p>
        <p className="text-sm mt-1 font-medium text-gray-500">
          All selected files are successfully processed and read to import,
        </p>
      </div>
      <div className="bg-gray-200 p-3 w-[70%] mt-4 rounded-xl">
        <div className="flex gap-4 items-center">
          <FaCheck className="text-green-500" />
          <div>
            <p className="font-medium">{fileName}</p>
            <p className="text-sm"  >Processed</p>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between w-[50%] mt-3 bg-[#333] p-1 rounded-md gap-2">
        <button
          onClick={() => setProcessBtn(false)}
          className="w-1/2 py-3 rounded bg-[#474747] text-white border-none outline-none cursor-pointer hover:bg-black duration-300 hover:text-white"
        >
          Cancel
        </button>
        <button className="w-1/2 py-3 rounded bg-green-500 text-white border-none outline-none cursor-pointer hover:bg-green-600 duration-300 hover:text-white" onClick={()=>handleShow() } >
                   Save Field
        </button>
        {/* <button className="w-1/2 py-3 rounded bg-green-500 text-white border-none outline-none cursor-pointer hover:bg-green-600 duration-300 hover:text-white" onClick={()=>setSelector(false) } >
                   Done
        </button> */}
       
      
      </div>
      {
        show && < AreaDetailSidebar 
        onCancel={handleCancel}
        kmlCoordinates={kmlCoordinates}
        setSelector={setSelector}
        
        />
      }
    </div>
  )
};

export default ProcessImg;